import React, { Fragment, lazy, Suspense } from 'react';
import { Skeleton } from '@/components/atoms/Skeleton';
import { useTheme } from 'styled-components';
import { useHomeData } from '@/hooks/useHomeData';

// import MinhaCarteiraDetalhamentoFallback from '@/components/organisms/MinhaCarteiraDetalhamento/fallback';
import ListagemCreditosHomeFallbackMobile from '@/components/organisms/ListagemCreditosHome/fallback/Designs/Mobile';
import BeneficiosChippuMobileFallback from '@/components/organisms/BeneficiosChippu/Designs/Mobile/fallback';
import {
  PrimeiraSecaoHomeMobile,
  SegundaSecaoHomeMobile,
  UltimaSecaoHomeMobile,
} from './styles';

const CarouselDestaques = lazy(
  () => import('@/components/organisms/CarouselDestaques'),
);
const Carousel = lazy(() => import('@/components/organisms/Carousel'));
const BeneficiosChippu = lazy(
  () => import('@/components/organisms/BeneficiosChippu'),
);
const AssinaturasRecorrentes = lazy(
  () => import('@/components/organisms/AssinaturasRecorrentes'),
);
const MinhaCarteiraDestaque = lazy(
  () => import('@/components/organisms/MinhaCarteiraDestaque'),
);
const DestaquesDaSemana = lazy(
  () => import('@/components/organisms/DestaquesDaSemana'),
);
// const MinhaCarteiraDetalhamento = lazy(
//   () => import('@/components/organisms/MinhaCarteiraDetalhamento'),
// );
const ListagemCreditosHomeTemplate = lazy(
  () => import('@/components/organisms/ListagemCreditosHome'),
);
const PlanosDisponiveis = lazy(
  () => import('@/components/organisms/PlanosDisponiveis'),
);

export default function HomePaginaMobile() {
  const theme = useTheme();
  const { destaquesMobile, combos, bannersCarousel } = useHomeData();

  return (
    <Fragment>
      <Suspense fallback={<Skeleton style={{ height: 478 }} />}>
        <CarouselDestaques destaques={bannersCarousel} />
      </Suspense>
      <PrimeiraSecaoHomeMobile>
        <Suspense fallback={<BeneficiosChippuMobileFallback />}>
          <BeneficiosChippu />
        </Suspense>
        <Suspense fallback={<Skeleton style={{ height: 298 }} />}>
          <Carousel
            $destaques={destaquesMobile}
            $mostrarControles={true}
            $styleImagem={{
              aspectRatio: '585 / 280',
            }}
            $imageStyle={{
              borderRadius: theme.radius[3],
              objectPosition: 'center right',
            }}
          />
        </Suspense>
        <Suspense fallback={<Skeleton style={{ height: 298 }} />}>
          <AssinaturasRecorrentes />
        </Suspense>
      </PrimeiraSecaoHomeMobile>
      <SegundaSecaoHomeMobile>
        <Suspense fallback={<Skeleton style={{ height: 616 }} />}>
          <MinhaCarteiraDestaque />
        </Suspense>
      </SegundaSecaoHomeMobile>
      <UltimaSecaoHomeMobile style={{ marginTop: theme.spacing[6] }}>
        <Suspense fallback={<Skeleton style={{ height: 868 }} />}>
          <DestaquesDaSemana />
        </Suspense>
        {combos?.length ? (
          <PlanosDisponiveis style={{ paddingTop: theme.spacing[5] }} />
        ) : null}
        <Suspense fallback={<ListagemCreditosHomeFallbackMobile />}>
          <ListagemCreditosHomeTemplate />
        </Suspense>
        {/* <Suspense fallback={<MinhaCarteiraDetalhamentoFallback />}>
          <MinhaCarteiraDetalhamento />
        </Suspense> */}
      </UltimaSecaoHomeMobile>
    </Fragment>
  );
}
